import { render, staticRenderFns } from "./pdf-content.component.vue?vue&type=template&id=07db97d0&scoped=true&"
import script from "./pdf-content.component.vue?vue&type=script&lang=ts&"
export * from "./pdf-content.component.vue?vue&type=script&lang=ts&"
import style0 from "./pdf-content.component.vue?vue&type=style&index=0&id=07db97d0&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07db97d0",
  null
  
)

export default component.exports